import { render, staticRenderFns } from "./parent-simplified.vue?vue&type=template&id=1ac18f4c&scoped=true&"
import script from "./parent-simplified.vue?vue&type=script&lang=ts&"
export * from "./parent-simplified.vue?vue&type=script&lang=ts&"
import style0 from "./parent-simplified.vue?vue&type=style&index=0&id=1ac18f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac18f4c",
  null
  
)

export default component.exports